// front/src/api/todos.js
import { apiFetch } from '../utils/apiFetch';

/** Config complète (admin) : natures actives ET inactives + champs */
export async function getTodoConfig() {
  const res = await apiFetch('/api/admin/settings/todo', { method: 'GET' });
  if (!res.ok) throw new Error('Impossible de charger la configuration');
  return res.json();
}

export async function getParamDefTodo() {
  const res = await apiFetch('/api/todos/paramDeftodos', { method: 'GET' });
  if (!res.ok) throw new Error('Impossible de charger la configuration');
  return res.json();
}

/** Enregistre la config (admin). Lève une erreur avec le message serveur (422...) si refus. */
export async function setTodoConfig(cfg) {
  const res = await apiFetch('/api/admin/settings/todo', {
    method: 'PUT',
    body: JSON.stringify(cfg),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Echec de l'enregistrement");
  }
  return res.json();
}

/** Config du formulaire de création : natures actives uniquement + champs */
export async function getTodoConfigPublic() {
  const res = await apiFetch('/api/todos/config', { method: 'GET' });
  if (!res.ok) throw new Error('Impossible de charger la configuration');
  return res.json();
}

/** Établissements (entité du créateur) + rôles ciblables */
export async function getTodoCibles() {
  const res = await apiFetch('/api/todos/cibles', { method: 'GET' });
  if (!res.ok) throw new Error('Impossible de charger les cibles');
  return res.json();
}

/** Liste des todos visibles. opts: { statut, profileId, roles[], mine } */
export async function listTodos({ statut, profileId, roles, mine } = {}) {
  const q = new URLSearchParams();
  if (statut) q.set('statut', statut);
  if (profileId) q.set('profileId', profileId);
  if (roles && roles.length) q.set('roles', roles.join(','));
  if (mine) q.set('mine', '1');
  const qs = q.toString();
  const res = await apiFetch(`/api/todos${qs ? `?${qs}` : ''}`, { method: 'GET' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || 'Impossible de charger les To Do');
  }
  return res.json();
}

/** Détail d'un todo (avec PII si autorisé). */
export async function getTodoDetail(id, profileId) {
  const q = profileId ? `?profileId=${encodeURIComponent(profileId)}` : '';
  const res = await apiFetch(`/api/todos/${id}${q}`, { method: 'GET' });
  if (!res.ok) throw new Error('Todo introuvable');
  return res.json();
}

/** Crée un todo. payload: { natureCode, cibles:[{role, etablissementId}], profilDemandeurId, urgence?, nom?, prenom?, dateNaissance?, sexe?, champLibre?, doctolibRef? } */
export async function createTodo(payload) {
  const res = await apiFetch('/api/todos', { method: 'POST', body: JSON.stringify(payload) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Echec de la création de la todo');
  return data;
}

/** Met à jour un todo (statut / urgence / libellé). payload: { statutCode?, urgence?, libelle?, profileId } */
export async function updateTodo(id, payload) {
  const res = await apiFetch(`/api/todos/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Echec de la mise à jour');
  return data;
}
